import { LoadingConstants, useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import React from 'react';
import BillingConstants from '../constants/BillingConstants';
import { emitDownloadInvoicesEvent } from '../model/ClickstreamEvents';
import { downloadBase64Data } from '../utils/downloadUtils';
import { AdproductsUserBillingInvoiceApiHandler_downloadInvoices } from '@zg-rentals/ts-adproducts-client';

export const useInvoiceDownloader = () => {
  const [downloadState, setDownloadState] = React.useState<LoadingConstants>(LoadingConstants.INITIAL);
  const [downloadErrorMessage, setDownloadErrorMessage] = React.useState('');

  const { user } = useRentalManagerUser();
  const getInvoices = (invoiceNumbers: Array<string>) => {
    emitDownloadInvoicesEvent({ user });
    setDownloadState(LoadingConstants.LOADING);
    AdproductsUserBillingInvoiceApiHandler_downloadInvoices({ invoiceNumbers })
      .then((result) => {
        const { data, fileName } = result;
        downloadBase64Data(data, 'application/octet-stream', fileName);
        return setDownloadState(LoadingConstants.SUCCESS);
      })
      .catch(() => {
        setDownloadErrorMessage(BillingConstants.DOWNLOAD_ERROR_MESSAGE);
        setDownloadState(LoadingConstants.ERROR);
      });
  };

  const resetDownloadState = () => {
    setDownloadState(LoadingConstants.INITIAL);
    setDownloadErrorMessage('');
  };

  return React.useMemo(
    () => ({
      downloadState,
      downloadErrorMessage,
      getInvoices,
      resetDownloadState,
    }),
    [downloadState, downloadErrorMessage],
  );
};
